import React from 'react';
import SpeedDialContext from './SpeedDialContext';
import Type from './SpeedDialContextType';

export default function useSpeedDial() {
  return React.useContext(SpeedDialContext) as Type;
}
